module.exports = __webpack_public_path__ + "img/message-read.7ef008d8.svg";